"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const react_1 = __importStar(require("react"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const ui_theme_1 = require("@kyruus/ui-theme");
const styles_1 = require("./styles");
const MUITooltipComponent = (0, ui_theme_1.withMuiThemeAdapter)(Tooltip_1.default);
const Tooltip = ({ id, title, placement, children }) => {
    const [open, setOpen] = (0, react_1.useState)(false);
    const onOpen = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };
    const onKeyDown = (e) => {
        if (e.key === 'Escape') {
            setOpen(false);
        }
    };
    const child = (0, react_1.cloneElement)(react_1.Children.only(children), {
        onKeyDown: (event) => {
            var _a, _b;
            onKeyDown(event);
            (_b = (_a = children.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        },
        onFocus: (event) => {
            var _a, _b;
            onOpen();
            (_b = (_a = children.props).onFocus) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        },
        onBlur: (event) => {
            var _a, _b;
            onClose();
            (_b = (_a = children.props).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        }
    });
    return (react_1.default.createElement(MUITooltipComponent, { title: title, open: open, arrow: true, placement: placement, onOpen: onOpen, onClose: onClose, PopperComponent: (props) => {
            return react_1.default.createElement(styles_1.StyledPopper, Object.assign({ id: id }, props));
        }, 
        // 👇🏽 makes the tooltip show up on touch for mobile
        enterTouchDelay: 0, disableFocusListener: true }, child));
};
exports.Tooltip = Tooltip;
exports.default = exports.Tooltip;
//# sourceMappingURL=index.js.map